module.exports = __webpack_public_path__ + "static/media/conversation_.31377a04.svg";